<template>
  <a-modal
    title="取消面试"
    :destroyOnClose="true"
    v-model="visible"
    :confirmLoading="loading"
    @ok="handleOk"
  >
    <a-form :form="form">
      <a-form-item label="取消面试原因">
        <a-textarea
          placeholder="请填写取消面试原因"
          :rows="6"
          v-decorator="[
            'cancel_reason',
            { rules: [{ required: true, message: '请填写原因' }] }
          ]"
        ></a-textarea>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import Api from "@/api";
export default {
  name: "CancelInterviewModal",
  data() {
    return {
      visible: false,
      loading: false,
      record: {},
      form: this.$form.createForm(this)
    };
  },
  methods: {
    show(record) {
      this.record = { ...record };
      this.visible = true;
    },
    close() {
      this.selectedTags = [];
      this.stage = 0;
      this.loading = false;
      this.visible = false;
    },
    handleOk() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.loading = true;
          try {
            await Api.order.interviewCancel({
              ...values,
              post_id: this.record.id
            });
            this.close();
            this.$emit("ok");
          } catch (e) {}
          this.loading = false;
        }
      });
    }
  }
};
</script>
<style lang="scss"></style>
